import { Site } from "../types";

export class Role {
    public static SiteAdmin = 1;
    public static Driver = 2;
    public static TaskOffice = 3;
    public static Gate = 4;
    public static DriverSupervisor = 5;
    public static Transportation = 6;
    public static Auditor = 7;
    public static BasicTaskOffice = 8;
}

export interface SiteRoleGroup {
    site: Site | null;
    role: Role[] | null;
  }
